/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function ParcelField (props: FormTextFieldProps) {
  const { name = 'parcel', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'parcel',
        defaultMessage: 'Lot/Parcelle'
      })}
      name={name}
      {...others}
    />
  )
}

export default ParcelField
